import isFullArray from 'utils/predicates/array/isFullArray.util';

const isNotFullArray = (value) => !isFullArray(value);

// noinspection JSUnusedGlobalSymbols
export default isNotFullArray;
